/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationService {
  matDialog = inject(MatDialog);

  /*
   * Opens a confirmation dialog.
   * @param actionToPerform The action to perform.
   * @return whether the user answersed positively or negatively
   */
  async openConfirmationDialog(
    actionToPerform: string,
    infoNote?: string,
    isDeleteAction?: boolean,
    actionButtonText?: string,
  ): Promise<boolean> {
    const dialogRef = this.matDialog.open(ConfirmDialogComponent, { width: '400px' });
    dialogRef.componentInstance.actionToPerform.set(actionToPerform);
    if (infoNote) {
      dialogRef.componentInstance.infoNote.set(infoNote);
    }
    if (isDeleteAction) {
      dialogRef.componentInstance.isDeleteDialog.set(isDeleteAction);
    }
    if (actionButtonText) {
      dialogRef.componentInstance.actionButtonText.set(actionButtonText);
    }
    return (await firstValueFrom(dialogRef.afterClosed())) === true;
  }
}
